export function getPaymentStatusText(paymentStatus: number, deliveryDate: string) {
  const today = new Date().toISOString().split('T', 1)[0]
  let infoText = 'Reserverad'

  if (paymentStatus === 200) {
    infoText = 'Betald'
  } else if (paymentStatus === 300) {
    infoText = 'Misslyckad'
  } else if (paymentStatus === 400)  {
    infoText = 'Avbruten'
  } else if (paymentStatus !== 200 && deliveryDate === today) {
    infoText = 'Pågående'
  }
  return infoText
}